import VAvatarBrief from './index.vue';

export default {
  install: (Vue) => Vue.component('VAvatarBrief', VAvatarBrief),
};
